module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-6-7de28c4639e47135a0cab9805b2f5670.jpg";